import * as React from 'react';
import BpmEdit from './BpmEdit';
import CaloriesEdit from './CaloriesEdit';
import EcgEdit from './EcgEdit';
import * as Sentry from '@sentry/browser';
import PictureBpmEdit from './PictureBpmEdit';
import SoundBpmEdit from './SoundBpmEdit';
import HeartAnimationEdit from './HeartAnimationEdit';
import RealTimeGraphWidgetEdit from './RealTimeGraphWidgetEdit';
import MaxEdit from './MaxEdit';
import {
  MetaJumpScareCounterWidget,
  MeatBeatsSaberV2Widget,
  MeatDeathloopWidget,
  MetaBeatsSaberWidget,
  MetaBpmAdvancedWidget,
  MetaBpmBasicWidget,
  MetaBpmPercentageWidget,
  MetaBpmWidget,
  MetaCaloriesWidget,
  MetaCyberpunkHeartWidget,
  MetaEcgWidget,
  MetaFitnessZoneWidget,
  MetaGaugeWidget,
  MetaGeometryDashWidget,
  MetaGraphWidget,
  MetaHalloweenMoon,
  MetaHeartAnimationWidget,
  MetaMaxWidget,
  MetaPictureWidget,
  MetaPixelWidget,
  MetaPulsoidMedicalWidget,
  MetaRealHeartWidget,
  MetaSoundWidget,
  MetaSoundWidgetV2,
  MetaStromnoWdiget,
  MetaTextWidget,
  MetaValorantWidget,
  MetaVideoWidget,
  MetaWindowsNtWidget,
  MetaGraphV2,
  MetaGlowyWidget,
  MetaMinecraftWidget,
  MetaReferralWidget,
  MetaResidentEvilWidget,
  MetaDeadByDaylightWidget,
  MetaDeadSpaceWidget,
  MetaChristmasWidget,
  MetaSpeedtestWidget,
  MetaPrideBpmBasicWidget,
  MetaDiabloWidget,
  MetaUnicornWidget,
  MetaAnimeBarWidget,
  MetaAlanWakeWidget,
  MetaAloneInTheDarkWidget,
  MetaFalloutWidget,
  MetaStarWarsWidget,
  MetaValorantWidgetV2,
  MetaEldenRingWidget,
  MetaSilentHill2Widget,
  MetaPredictionWidget,
  MetaStalkerWidget,
  MetaPulsatingWidget,
  MetaMonsterHunterWidget,
} from '@pulsoid-private/widgets-lib';
import {TextWidgetEdit} from './TextWidgetEdit';
import {VideoEdit} from './VideoEdit';
import {FitnessZoneEdit} from './FitnessZoneEdit';
import BpmPercentageEdit from './BpmPercentageEdit';
import {GaugeWidgetEdit} from './GaugeWidgetEdit';
import BpmBasicEdit from './BpmBasicEdit';
import GeometryDashEdit from './GeometryDashbEdit';
import BeatSabersV2Edit from './BeatSabersV2Edit';
import {SoundWidgetV2Edit} from './SoundWidgetV2Edit';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';
import RealTimeGraphWidgetV2Edit from './RealTimeGraphWidgetV2Edit';
import GlowyWidgetEdit from './GlowyWidgetEdit';
import MinecraftWidgetEdit from './MinecraftWidgetEdit';
import ReferralEdit from './ReferralEdit';
import {ResidentEvilEdit} from './ResidentEvilEdit';
import {DeadByDaylightEdit} from './DeadByDaylightEdit';
import {DeadSpaceEdit} from './DeadSpaceEdit';
import {ChristmasWidgetEdit} from './ChristmasWidgetEdit';
import {BpmAdvancedEdit} from './BpmAdvancedEdit/BpmAdvancedEdit';
import {SpeedTestEdit} from './SpeedTestEdit';
import {PrideBpmBasicEdit} from './PrideBpmBasicEdit';
import {DiabloEdit} from './DiabloEdit';
import {UnicornEdit} from './UnicornEdit';
import {AnimeBarWidgetEdit} from './AnimeBarWidgetEdit';
import {JumpScareCounterEditNew} from './JumpScareCounterEditNew';
import {AlanWakeWidgetEdit} from './AlanWakeWidgetEdit';
import {FalloutWidgetEdit} from './FalloutWidgetEdit';
import {ValorantWidgetV2Edit} from './ValorantWidgetV2Edit';
import {EldenRingWidgetEdit} from './EldenRingWidgetEdit';
import {PredictionWidgetEdit} from './PredictionWidgetEdit';
import {StalkerWidgetEdit} from './StalkerWidgetEdit';
import {PulsatingCircleWidgetEdit} from './PulsatingCircleWidgetEdit';
import {MonsterHunterWidgetEdit} from './MonsterHunterWidgetEdit';

function getEditComponentByMetaWidgetId(metaId) {
  switch (metaId) {
    case MetaPixelWidget:
      return () => <div />;
    case MetaRealHeartWidget:
      return () => <div />;
    case MetaBpmWidget:
      return (props) => <BpmEdit {...props} />;
    case MetaCaloriesWidget:
      return (props) => <CaloriesEdit {...props} />;

    case MetaEcgWidget:
      return (props) => <EcgEdit {...props} />;
    case MetaPictureWidget:
      return (props) => <PictureBpmEdit {...props} />;
    case MetaSoundWidget:
      return (props) => <SoundBpmEdit {...props} />;
    case MetaHeartAnimationWidget:
      return (props) => <HeartAnimationEdit {...props} />;
    case MetaGraphWidget:
      return (props) => <RealTimeGraphWidgetEdit {...props} />;
    case MetaMaxWidget:
      return (props) => <MaxEdit {...props} />;
    case MetaTextWidget:
      return (props) => <TextWidgetEdit {...props} />;
    case MetaVideoWidget:
      return (props) => <VideoEdit {...props} />;
    case MetaFitnessZoneWidget:
      return (props) => <FitnessZoneEdit {...props} />;
    case MetaValorantWidget:
      return () => <div />;
    case MetaValorantWidgetV2:
      return (props) => <ValorantWidgetV2Edit {...props} />;

    case MetaEldenRingWidget:
      return (props) => <EldenRingWidgetEdit {...props} />;

    case MetaPulsoidMedicalWidget:
      return () => <div />;

    case MetaCyberpunkHeartWidget:
      return () => <div />;

    case MetaBeatsSaberWidget:
      return () => <div />;

    case MetaWindowsNtWidget:
      return () => <div />;

    case MetaStromnoWdiget:
      return () => <div />;
    case MetaBpmPercentageWidget:
      return (props) => <BpmPercentageEdit {...props} />;
    case MetaGaugeWidget:
      return (props) => <GaugeWidgetEdit {...props} />;
    case MetaBpmBasicWidget:
      return (props) => <BpmBasicEdit {...props} />;
    case MetaBpmAdvancedWidget:
      return (props) => <BpmAdvancedEdit {...props} />;
    case MetaGeometryDashWidget:
      return (props) => <GeometryDashEdit {...props} />;
    case MeatBeatsSaberV2Widget:
      return (props) => <BeatSabersV2Edit {...props} />;
    case MetaSoundWidgetV2:
      return (props) => (
        <PremiumWrapperOverlay disabled={!props.premiumUpdate}>
          <SoundWidgetV2Edit {...props} />
        </PremiumWrapperOverlay>
      );
    case MetaJumpScareCounterWidget:
      return (props) => <JumpScareCounterEditNew {...props} />;
    case MeatDeathloopWidget:
      return () => <div />;
    case MetaHalloweenMoon:
      return () => <div />;
    case MetaGraphV2:
      return (props) => <RealTimeGraphWidgetV2Edit {...props} />;
    case MetaGlowyWidget:
      return (props) => <GlowyWidgetEdit {...props} />;
    case MetaMinecraftWidget:
      return (props) => <MinecraftWidgetEdit {...props} />;
    case MetaReferralWidget:
      return (props) => <ReferralEdit {...props} />;
    case MetaResidentEvilWidget:
      return (props) => <ResidentEvilEdit {...props} />;
    case MetaDeadByDaylightWidget:
      return (props) => <DeadByDaylightEdit {...props} />;
    case MetaDeadSpaceWidget:
      return (props) => <DeadSpaceEdit {...props} />;
    case MetaChristmasWidget:
      return (props) => <ChristmasWidgetEdit {...props} />;
    case MetaSpeedtestWidget:
      return (props) => <SpeedTestEdit {...props} />;
    case MetaPrideBpmBasicWidget:
      return (props) => <PrideBpmBasicEdit {...props} />;
    case MetaDiabloWidget:
      return (props) => <DiabloEdit {...props} />;
    case MetaUnicornWidget:
      return (props) => <UnicornEdit {...props} />;
    case MetaAnimeBarWidget:
      return (props) => <AnimeBarWidgetEdit {...props} />;
    case MetaAlanWakeWidget:
      return (props) => <AlanWakeWidgetEdit {...props} />;
    case MetaAloneInTheDarkWidget:
      return () => <div />;
    case MetaFalloutWidget:
      return (props) => <FalloutWidgetEdit {...props} />;
    case MetaSilentHill2Widget:
      return () => <div />;
    case MetaStarWarsWidget:
      return () => (
        <div>
          This is a beta version of the widget featuring an upward scrolling
          text effect. If you encounter any bugs, please send a report
          accompanied by a screen recording or clip to{' '}
          <a href="mailto:support@pulsoid.net">support@pulsoid.net</a>
        </div>
      );

    case MetaPredictionWidget:
      return (props) => <PredictionWidgetEdit {...props} />;
    case MetaStalkerWidget:
      return (props) => <StalkerWidgetEdit {...props}></StalkerWidgetEdit>;
    case MetaPulsatingWidget:
      return (props) => <PulsatingCircleWidgetEdit {...props} />;
    case MetaMonsterHunterWidget:
      return (props) => <MonsterHunterWidgetEdit {...props} />;

    default:
      return () => {
        Sentry.captureMessage('unknown meta id ' + metaId);
        return <div>Smt went wrong</div>;
      };
  }
}

export {getEditComponentByMetaWidgetId};
